import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { TableContainer, showInfo } from '@/components';
import { Table } from 'antd';
import styled from 'styled-components';
const Line = styled.div `
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #999999;
  span {
    font-size: 18px;
    color: #ff571a;
  }
`;
const mapStateToProps = (rootState) => ({
    _state: rootState.groupMoneyManage,
});
class UserTable extends Component {
    constructor(props) {
        super(props);
        this.dealScroll = () => {
            let changeX = 0;
            const { columns } = this.state;
            columns.forEach((v) => {
                changeX += v.width ? v.width : 150;
            });
            return { x: changeX };
        };
        this.changePage = (e) => {
            dispatch.groupMoneyManage.SET_PAGE_CURRENT(e);
            dispatch.groupMoneyManage.load({});
        };
        this.state = {
            columns: [
                {
                    title: '序列',
                    dataIndex: 'number',
                    width: 54,
                },
                {
                    title: '时间',
                    dataIndex: 'createTime',
                    width: 122,
                },
                {
                    title: '状态',
                    dataIndex: 'statusStr',
                    width: 56,
                },
                {
                    title: '金额(元)',
                    dataIndex: 'money',
                    width: 127,
                },
                {
                    title: '可用保证金余额(元)',
                    dataIndex: 'balance',
                    width: 170,
                },
                {
                    title: '明细类型',
                    dataIndex: 'typeStr',
                    width: 86,
                },
                {
                    title: '卖家经销商',
                    dataIndex: 'shopName',
                    width: 110,
                    render: (text, record, index) => {
                        if (record.shopCode) {
                            return (<a href="javascript:;" onClick={() => showInfo('seller', record.shopCode)}>
                  {text}
                </a>);
                        }
                        return text;
                    },
                },
                {
                    title: '其他信息',
                    dataIndex: 'desc',
                    width: 380,
                },
            ],
        };
    }
    componentWillMount() {
        dispatch.groupMoneyManage.load({});
    }
    render() {
        const { totalNum, items, currentIndex, pageSize, tableLoading } = this.props._state;
        const { columns } = this.state;
        return (<TableContainer className="table__container" hasExport={false}>
        <Line className="table__top">
          共搜索到{totalNum}条数据
        </Line>
        <Table className="draw_table_all_border" dataSource={items} columns={columns} pagination={{
            current: currentIndex,
            pageSize,
            showQuickJumper: true,
            total: totalNum,
            onChange: this.changePage,
        }} loading={tableLoading} scroll={this.dealScroll()}/>
      </TableContainer>);
    }
}
export default connect(mapStateToProps)(UserTable);
